import { Download } from "lucide-react";
import { Button } from "@sfc/ui";
import { trpc, trpcVanilla } from "@client/trpc";
import { toast } from "sonner";

export function RoundVideoDownload({
  roundId,
  viewerId,
  iconOnly = false,
  withDetails = false,
}: {
  roundId: string;
  viewerId: string;
  iconOnly?: boolean;
  withDetails?: boolean;
}) {
  const query = trpc.getRoundVideoExport.useQuery(
    { roundId, clientQueryScope: viewerId },
    {
      staleTime: 0,
      refetchInterval: (q) =>
        q.state.data?.latest?.status === "RUNNING" ||
        q.state.data?.latest?.status === "QUEUED"
          ? 3000
          : false,
    },
  );
  const available = query.data?.available;

  if (!available) {
    return null;
  }

  const button = (
    <Button
      variant={iconOnly ? "nav" : "flat-outline"}
      size={iconOnly ? "icon" : "default"}
      className={iconOnly ? "rounded-full" : undefined}
      aria-label="Download video ZIP"
      title="Download video ZIP"
      onClick={async () => {
        try {
          const result = await trpcVanilla.getRoundVideoExportDownload.query({
            roundId,
            runId: available.runId,
          });
          const anchor = document.createElement("a");
          anchor.href = result.url;
          anchor.download = result.filename;
          anchor.rel = "noopener";
          anchor.click();
        } catch {
          toast.error(
            "Could not download the video ZIP. Your access may have changed.",
          );
        }
      }}
    >
      {iconOnly ? (
        <Download className="size-5" aria-hidden="true" />
      ) : withDetails ? (
        <>
          <Download className="size-4" aria-hidden="true" />
          Download ZIP
        </>
      ) : (
        "Download video ZIP"
      )}
    </Button>
  );

  return withDetails ? (
    <div className="flex flex-wrap items-center justify-between gap-4 border-t border-border-subtle pt-4">
      <div>
        <p className="body-md font-medium">Round videos</p>
        <p className="body-sm text-text-secondary">
          720p where available · Original quality otherwise
        </p>
      </div>
      {button}
    </div>
  ) : (
    button
  );
}
